import React from "react";
import { Button, Dropdown, Checkbox } from "react-materialize";
import $ from "jquery";
import config from "../../config";
import API from "../../utils/API";
import Func from "../../utils/Func";

import { useAlluser } from "context/AlluserContext";

export default function BtnAction({
  setActionData,
  actionData,
  active_page,
  userSess,
}) {
  const { filters, storeFilters } = useAlluser();
  let userData = window.$user_profile;
  const handleEvents = {
    OnChange: function (evt) {
      evt.preventDefault();
      let form = $(evt.target).parents("form").first();
      let items = $(form).find("input[name=action_items]").val();
      if (items === "") {
        items = [];
      } else {
        items = JSON.parse(items);
      }
      $(form)
        .find("input[name='action-item']")
        .each(function () {
          let value = parseInt($(this).val());
          const pos = items.indexOf(value);
          if (evt.target.checked) {
            if (pos === -1) {
              items.push(value);
            }
          } else {
            if (pos > -1) {
              items.splice(pos, 1);
            }
          }
        });
      // Pages
      let pages = $(form).find("input[name=action_pages]").val();
      if (pages === "") {
        pages = [];
      } else {
        pages = JSON.parse(pages);
      }
      const pos_page = pages.indexOf(active_page);
      if (evt.target.checked && pos_page === -1) {
        pages.push(active_page);
      } else if (!evt.target.checked && pos_page > -1) {
        pages.splice(pos_page, 1);
      }

      setActionData({
        ...actionData,
        key: Math.floor(Math.random() * 10000 + 1),
        items: items,
        pages: pages,
      });
    },
  };
  handleEvents.BtnTypeAction = {
    OnClick: function (type) {
      // setItemData({ status: "inprocess" });
      const mainFunc = async () =>
        await API.post("alluser/save/userdata", {
          params: ({
            userID: userData.idu,
            userEmail: userData.emailadd,
            type: type,
            updateUserIDs: actionData.items,
          }),
        });
      mainFunc()
        .then((res) => {
          const decrypt = (res?.data);
          // console.log("alluser save userdata=", decrypt);
          if (decrypt?.status === "success") {
            storeFilters({ ...filters, keyChange: Func.GetKeyRandom() });
          }
        })
        .catch((err) => {
          //console.log(infos.tabActive, err);
        });
    },
  };
  // console.log("actionData=>", actionData);
  let action_pages = "pages" in actionData ? actionData.pages : [];
  let actionChecked = action_pages.indexOf(active_page) > -1 ? true : false;
  let btn_options = [];
  btn_options.push(
    <span
      key="btn-action-activate"
      className="btn-open-modal-action"
      id="btn-action-activate"
      data-type="activate"
      onClick={() => handleEvents.BtnTypeAction.OnClick("activate")}
    >
      Activate
    </span>
  );
  btn_options.push(
    <span
      key="btn-action-deactivate"
      className="btn-open-modal-action"
      id="btn-action-deactivate"
      data-type="deactivate"
      onClick={() => handleEvents.BtnTypeAction.OnClick("deactivate")}
    >
      Deactivate
    </span>
  );
  btn_options.push(
    <span
      key="btn-action-delete"
      className="btn-open-modal-action red-text"
      id="btn-action-delete"
      data-type="delete"
      onClick={() => handleEvents.BtnTypeAction.OnClick("delete")}
    >
      Flag as Delete
    </span>
  );

  return (
    <div key="btn-bulk-action" style={{ marginTop: "-9px" }}>
      <Dropdown
        id={"dropdown-bulk-action"}
        options={{
          alignment: "left",
          autoTrigger: true,
          closeOnClick: true,
          constrainWidth: true,
          container: null,
          coverTrigger: true,
          hover: false,
          inDuration: 150,
          onCloseEnd: null,
          onCloseStart: null,
          onOpenEnd: null,
          onOpenStart: null,
          outDuration: 250,
        }}
        trigger={
          <Button
            flat
            node="button"
            style={{
              float: "left",
              width: "110px",
              fontWeight: "bold",
              padding: "0px",
              whiteSpace: "nowrap",
              fontSize: "13px",
            }}
          >
            <i className="material-icons right">arrow_drop_down</i>Actions
          </Button>
        }
      >
        {btn_options}
      </Dropdown>
      <Checkbox
        key={"action-all-item-" + actionData.key}
        checked={actionChecked}
        filledIn
        name="action-all-item"
        label=""
        value="1"
        onClick={handleEvents.OnChange}
      />
    </div>
  );
}

